import {
  GET_DATA_RETENTION_POLICIES,
  GET_DATA_RETENTION_POLICIES_SUCCESS,
  GET_DATA_RETENTION_POLICIES_ERROR,
} from './actionTypes';

export const getDataRetentionPolicies = (user) => {
  return {
    type: GET_DATA_RETENTION_POLICIES,
    payload: { user },
  };
};

export const getDataRetentionPoliciesSuccess = (policies, message) => {
  return {
    type: GET_DATA_RETENTION_POLICIES_SUCCESS,
    payload: { policies, message },
  };
};

export const getDataRetentionPoliciesError = (msg) => {
  return {
    type: GET_DATA_RETENTION_POLICIES_ERROR,
    payload: msg,
  };
};
